// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ──────────────────────────────────────────────────────────────────────────
   Reporting editor — two-pane layout.
   [ left rail: studies · patient · panels ]  [ editor: max space ]
   Palette: #7D48B0 accent · #E2E8F1 borders · #45556C muted · #F5EBFF selected
   ────────────────────────────────────────────────────────────────────────── */
.editor-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  min-height: 0;
}
/* Focus mode: drop cosmetic chrome around the editor to reclaim vertical space */
.editor-container.focus-mode .editor-section > .section-header {
  display: none;
}
.editor-container.focus-mode .signed-off-banner {
  display: none !important;
}
/* ── Left panes (studies · details) ──────────────────────────────────────── */
.report-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  min-height: 0;
  background: #fff;
  border-right: 0.0625rem solid #E2E8F1;
  -webkit-transition: -webkit-flex-basis 0.2s ease;
  transition: -webkit-flex-basis 0.2s ease;
  transition: flex-basis 0.2s ease;
  transition: flex-basis 0.2s ease, -webkit-flex-basis 0.2s ease, -ms-flex-preferred-size 0.2s ease;
}
.pane-studies { -webkit-box-flex: 0; -ms-flex: 0 0 12.5rem; flex: 0 0 12.5rem; }
.pane-details { -webkit-box-flex: 0; -ms-flex: 0 0 15rem; flex: 0 0 15rem; }
.report-pane.collapsed {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 1.75rem;
          flex: 0 0 1.75rem;
  overflow: hidden;
}
.rail-expand-btn {
  width: 100%;
  height: 2.25rem;
  border: none;
  background: #7D48B0;
  color: #fff;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 0.75rem;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}
.rail-expand-btn:hover {
  background: #6A3D9A;
}
.rail-header {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  height: 2.25rem;
  padding: 0 0.5rem 0 0.75rem;
  background: #7D48B0;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
}
.rail-header-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.4rem;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 0.8125rem;
  letter-spacing: 0.0025rem;
}
.rail-icon-btn {
  width: 1.4rem;
  height: 1.4rem;
  border: none;
  background: transparent;
  color: #fff;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-size: 0.7rem;
  border-radius: 0.25rem;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}
.rail-icon-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}
/* Scrollable body of each pane */
.rail-scroll {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.rail-empty {
  padding: 1rem 0.75rem;
  text-align: center;
  color: #94A3B8;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 0.75rem;
}
/* Thin scrollbars inside the panes */
.rail-scroll::-webkit-scrollbar {
  width: 0.375rem;
}
.rail-scroll::-webkit-scrollbar-thumb {
  background: #D5DEE6;
  border-radius: 0.25rem;
}
/* ── Studies queue item ──────────────────────────────────────────────────── */
.queue-item {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  border-left: 0.1875rem solid transparent;
  border-bottom: 0.0625rem solid #EEF2F6;
  background: #fff;
  padding: 0.4rem 0.625rem;
  cursor: pointer;
  -webkit-transition: background-color 0.15s;
  transition: background-color 0.15s;
}
.queue-item:hover {
  background: #F8F9FA;
}
.queue-item.active {
  background: #F5EBFF;
  border-left-color: #7D48B0;
}
.queue-item-name {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 0.8125rem;
  line-height: 1.2;
  color: #0F172A;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.queue-item-meta {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.375rem;
  margin-top: 0.15rem;
  font-size: 0.6875rem;
  color: #45556C;
  overflow: hidden;
}
.queue-item-desc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.queue-tag {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  padding: 0 0.3rem;
  border-radius: 0.25rem;
  background: #EDE3F7;
  color: #7D48B0;
  font-weight: 600;
  font-size: 0.625rem;
  line-height: 1.05rem;
  letter-spacing: 0.0125rem;
}
.queue-item-date {
  margin-top: 0.1rem;
  font-size: 0.625rem;
  color: #94A3B8;
}
/* ── Patient card ────────────────────────────────────────────────────────── */
.patient-card {
  padding: 0.625rem 0.75rem;
  border-bottom: 0.0625rem solid #E2E8F1;
}
.patient-card-name {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.4rem;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 0.8125rem;
  color: #0F172A;
}
.patient-card-icon {
  font-size: 0.875rem;
  color: #7D48B0;
}
.patient-card-meta {
  margin-top: 0.2rem;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 0.6875rem;
  line-height: 1.3;
  color: #45556C;
}
.patient-card-actions {
  margin-top: 0.5rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 0.4rem;
}
.rail-action-btn {
  height: 1.6rem;
  padding: 0 0.6rem;
  border-radius: 0.375rem;
  border: 0.0625rem solid #7D48B0;
  background: #fff;
  color: #7D48B0;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.75rem;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.rail-action-btn:hover {
  background: #F5EBFF !important;
  border-color: #7D48B0 !important;
  color: #7D48B0 !important;
}
/* ── Editor section (max space) ──────────────────────────────────────────── */
.editor-section {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-width: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}
.section-header {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  height: 2.25rem;
  padding: 0 1rem;
  background: #7D48B0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.section-header-title {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: 0.0025rem;
  color: #fff;
}
.section-content {
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}
.section-footer {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  padding: 0.5rem 0.75rem;
  background: #fff;
  border-top: 0.0625rem solid #E2E8F1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 0.5rem;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
}
.signed-off-banner {
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}
/* ── Footer buttons ──────────────────────────────────────────────────────── */
.footer-btn {
  height: 1.75rem;
  padding: 0.375rem 0.625rem;
  border-radius: 0.5rem;
  background-color: #fff;
  border: 0.0625rem solid #D5DEE6;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0.0025rem;
}
.footer-btn-signoff {
  height: 1.75rem;
  padding: 0.375rem 0.625rem;
  border-radius: 0.5rem;
  background-color: #7D48B0;
  border: 0.0625rem solid #7D48B0;
  color: #fff;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0.0025rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.4rem;
}
.footer-btn-signoff:hover {
  background-color: #6A3D9A !important;
  border-color: #6A3D9A !important;
  color: #fff !important;
}
/* Red variant for "Update Sign-off" (editing an already signed-off report) */
.footer-btn-signoff-update {
  background-color: #D4380D !important;
  border-color: #D4380D !important;
}
.footer-btn-signoff-update:hover {
  background-color: #AD2102 !important;
  border-color: #AD2102 !important;
  color: #fff !important;
}
/* Template panel buttons (rendered by TemplatePanel) */
.use-template-btn {
  height: 1.75rem;
  padding: 0.375rem 0.625rem;
  gap: 0.375rem;
  border-radius: 0.5rem;
  background: #fff;
  border: 0.0625rem solid #7D48B0 !important;
  -webkit-box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;
          box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0.0025rem;
  color: #7D48B0 !important;
}
.use-template-btn:hover {
  background: #F5EBFF !important;
  border-color: #7D48B0 !important;
  color: #7D48B0 !important;
}
.voice-transcribe-btn {
  height: 1.75rem;
  padding: 0.375rem 0.625rem;
  gap: 0.375rem;
  border-radius: 0.5rem;
  background: #fff !important;
  border: 0.125rem solid transparent !important;
  background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#fff)), -webkit-gradient(linear, left top, right top, from(#8149C4), to(#25E228)) !important;
  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #8149C4 0%, #25E228 100%) !important;
  background-origin: border-box !important;
  background-clip: padding-box, border-box !important;
  -webkit-box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;
          box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0.0025rem;
  color: #7D48B0 !important;
}
.voice-transcribe-btn:hover {
  background-image: -webkit-gradient(linear, left top, left bottom, from(#F5EBFF), to(#F5EBFF)), -webkit-gradient(linear, left top, right top, from(#8149C4), to(#25E228)) !important;
  background-image: linear-gradient(#F5EBFF, #F5EBFF), linear-gradient(90deg, #8149C4 0%, #25E228 100%) !important;
  background-origin: border-box !important;
  background-clip: padding-box, border-box !important;
  color: #7D48B0 !important;
}
/* ── Collapsible panels (rail) ───────────────────────────────────────────── */
.collapsible-section {
  border-bottom: 0.0625rem solid #E2E8F1;
  background: #fff;
}
.collapsible-header {
  height: 2.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  padding: 0 0.75rem;
  cursor: pointer;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}
.collapsible-header:hover {
  background-color: #F8F9FA;
}
.collapsible-header-left {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.4rem;
}
.collapsible-icon {
  font-size: 0.875rem;
  color: #45556C;
}
.collapsible-title {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 0.8125rem;
  letter-spacing: 0.0025rem;
  color: #0F172A;
}
.collapsible-arrow {
  font-size: 0.6875rem;
  color: #94A3B8;
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  transition: transform 0.2s;
  transition: transform 0.2s, -webkit-transform 0.2s;
}
.collapsible-content {
  padding: 0.5rem 0.75rem;
  background: #fff;
}
/* ── Report / prior list items ───────────────────────────────────────────── */
.report-list-item {
  padding: 0.4rem 0;
  border-bottom: 0.0625rem solid #EEF2F6;
  cursor: pointer;
}
.report-list-item:last-child {
  border-bottom: none;
}
.report-list-item:hover {
  background-color: #F8F9FA;
}
.report-item-line-1 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  color: #0F172A;
  margin-bottom: 0.15rem;
}
.report-item-line-2 {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 0.6875rem;
  color: #45556C;
  margin-bottom: 0.2rem;
}
.report-item-line-3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.no-content-message {
  text-align: center;
  color: #94A3B8;
  padding: 0.5rem 0;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 0.75rem;
}
/* Documents / notes list */
.report-notes-list {
  padding: 0.4rem 0.5rem;
  margin-bottom: 0.25rem;
  background-color: #F5F5F5;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  cursor: pointer;
  border: 0.0625rem solid #E8E8E8;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.report-notes-list.selected {
  color: #000 !important;
  border: none;
  background: #A27EC3 !important;
}
/* ── Advanced options ────────────────────────────────────────────────────── */
.advanced-option-item {
  margin-bottom: 0.625rem;
}
.advanced-option-item:last-child {
  margin-bottom: 0;
}
.notify-physician-link {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 0.4rem;
  color: #7D48B0;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
  cursor: pointer;
  text-decoration: none;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.notify-physician-link:hover {
  color: #6A3D9A;
  text-decoration: underline;
}
.notify-bell-icon {
  font-size: 0.875rem;
  color: #7D48B0;
}
.advanced-option-checkbox {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 0.8125rem;
  color: #0F172A;
}
.advanced-option-radio-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 0.4rem;
}
.radio-label {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
  color: #0F172A;
}
.error-message {
  color: #FF4D4F;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
/* ── External report header/footer (TinyMCE legacy support) ──────────────── */
#external-report-header {
  background: #fff;
  padding: 0.5rem 1.25rem;
  border-bottom: 0.0625rem solid #E8E8E8;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
#external-report-header strong {
  font-weight: 700;
}
#external-report-footer {
  background: #fff;
  padding: 0.375rem 1.25rem;
  border-top: 0.0625rem solid #E8E8E8;
  font-size: 0.8125rem;
  color: #333;
  line-height: 1.4;
  text-align: left;
}
/* ── TinyMCE toolbar tweaks ──────────────────────────────────────────────── */
.tox-tinymce {
  border-radius: 0 !important;
  width: 100% !important;
}
.tox-tinymce .tox-edit-area {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}
.tox-tinymce .tox-edit-area__iframe {
  max-width: 49.625rem;
  width: 49.625rem;
}
.tox button[data-mce-name="fontsize"],
.tox .tox-tbtn[data-mce-name="fontsize"] {
  width: 70px !important;
  max-width: 70px !important;
  min-width: 70px !important;
}
.tox button[data-mce-name="fontfamily"],
.tox .tox-tbtn[data-mce-name="fontfamily"] {
  width: 85px !important;
  max-width: 85px !important;
  min-width: 85px !important;
}
.tox button[data-mce-name="styles"],
.tox .tox-tbtn[data-mce-name="styles"] {
  width: 100px !important;
  max-width: 100px !important;
  min-width: 100px !important;
}
`, "",{"version":3,"sources":["webpack://./pages/Reporting/styles/editor.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;AAC/E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,YAAY;EACZ,aAAa;AACf;AAEA,iFAAiF;AACjF;EACE,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;AAEA,+EAA+E;AAC/E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,gDAAgC;EAAhC,wCAAgC;EAAhC,gCAAgC;EAAhC,iGAAgC;AAClC;AACA,gBAAgB,mBAAiB,EAAjB,qBAAiB,EAAjB,iBAAiB,EAAE;AACnC,gBAAgB,mBAAe,EAAf,mBAAe,EAAf,eAAe,EAAE;AAEjC;EACE,mBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAiC;EAAjC,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;AAChC;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;AAC3B;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,yCAAiC;EAAjC,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AAEA,iCAAiC;AACjC;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,6EAA6E;EAC7E,kBAAkB;AACpB;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AAEA,+EAA+E;AAC/E;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,0CAAkC;EAAlC,kCAAkC;AACpC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AAEA,+EAA+E;AAC/E;EACE,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,6EAA6E;EAC7E,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,WAAW;AACb;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,6EAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;EAClB,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;AAEA,+EAA+E;AAC/E;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AACA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,WAAW;EACX,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;AAC3B;AAEA;EACE,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;AAC3B;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,WAAW;EACX,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AAEA,6EAA6E;AAC7E;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;EAC1C,+DAAuD;UAAvD,uDAAuD;EACvD,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;EAC7C,6KAA0G;EAA1G,0GAA0G;EAC1G,wCAAwC;EACxC,mDAAmD;EACnD,+DAAuD;UAAvD,uDAAuD;EACvD,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,mLAAgH;EAAhH,gHAAgH;EAChH,wCAAwC;EACxC,mDAAmD;EACnD,yBAAyB;AAC3B;AAEA,+EAA+E;AAC/E;EACE,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yCAAiC;EAAjC,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,0CAA0B;EAA1B,kCAA0B;EAA1B,0BAA0B;EAA1B,kDAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AAEA,+EAA+E;AAC/E;EACE,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,6EAA6E;EAC7E,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,6EAA6E;EAC7E,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,6EAA6E;EAC7E,kBAAkB;AACpB;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,4BAAoB;EAApB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;AAEA,+EAA+E;AAC/E;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,4BAAoB;EAApB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,6EAA6E;EAC7E,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,cAAc;EACd,6EAA6E;EAC7E,kBAAkB;EAClB,mBAAmB;AACrB;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AAEA,+EAA+E;AAC/E;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B","sourcesContent":["/* ──────────────────────────────────────────────────────────────────────────\r\n   Reporting editor — two-pane layout.\r\n   [ left rail: studies · patient · panels ]  [ editor: max space ]\r\n   Palette: #7D48B0 accent · #E2E8F1 borders · #45556C muted · #F5EBFF selected\r\n   ────────────────────────────────────────────────────────────────────────── */\r\n.editor-container {\r\n  display: flex;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n/* Focus mode: drop cosmetic chrome around the editor to reclaim vertical space */\r\n.editor-container.focus-mode .editor-section > .section-header {\r\n  display: none;\r\n}\r\n.editor-container.focus-mode .signed-off-banner {\r\n  display: none !important;\r\n}\r\n\r\n/* ── Left panes (studies · details) ──────────────────────────────────────── */\r\n.report-pane {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  background: #fff;\r\n  border-right: 0.0625rem solid #E2E8F1;\r\n  transition: flex-basis 0.2s ease;\r\n}\r\n.pane-studies { flex: 0 0 12.5rem; }\r\n.pane-details { flex: 0 0 15rem; }\r\n\r\n.report-pane.collapsed {\r\n  flex: 0 0 1.75rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.rail-expand-btn {\r\n  width: 100%;\r\n  height: 2.25rem;\r\n  border: none;\r\n  background: #7D48B0;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.75rem;\r\n  transition: background-color 0.2s;\r\n}\r\n.rail-expand-btn:hover {\r\n  background: #6A3D9A;\r\n}\r\n\r\n.rail-header {\r\n  flex: 0 0 auto;\r\n  height: 2.25rem;\r\n  padding: 0 0.5rem 0 0.75rem;\r\n  background: #7D48B0;\r\n  color: #fff;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.rail-header-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.8125rem;\r\n  letter-spacing: 0.0025rem;\r\n}\r\n\r\n.rail-icon-btn {\r\n  width: 1.4rem;\r\n  height: 1.4rem;\r\n  border: none;\r\n  background: transparent;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.7rem;\r\n  border-radius: 0.25rem;\r\n  transition: background-color 0.2s;\r\n}\r\n.rail-icon-btn:hover {\r\n  background: rgba(255, 255, 255, 0.18);\r\n}\r\n\r\n/* Scrollable body of each pane */\r\n.rail-scroll {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.rail-empty {\r\n  padding: 1rem 0.75rem;\r\n  text-align: center;\r\n  color: #94A3B8;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n/* Thin scrollbars inside the panes */\r\n.rail-scroll::-webkit-scrollbar {\r\n  width: 0.375rem;\r\n}\r\n.rail-scroll::-webkit-scrollbar-thumb {\r\n  background: #D5DEE6;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n/* ── Studies queue item ──────────────────────────────────────────────────── */\r\n.queue-item {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: left;\r\n  border: none;\r\n  border-left: 0.1875rem solid transparent;\r\n  border-bottom: 0.0625rem solid #EEF2F6;\r\n  background: #fff;\r\n  padding: 0.4rem 0.625rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n.queue-item:hover {\r\n  background: #F8F9FA;\r\n}\r\n.queue-item.active {\r\n  background: #F5EBFF;\r\n  border-left-color: #7D48B0;\r\n}\r\n\r\n.queue-item-name {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.8125rem;\r\n  line-height: 1.2;\r\n  color: #0F172A;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.queue-item-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.375rem;\r\n  margin-top: 0.15rem;\r\n  font-size: 0.6875rem;\r\n  color: #45556C;\r\n  overflow: hidden;\r\n}\r\n.queue-item-desc {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.queue-tag {\r\n  flex: 0 0 auto;\r\n  padding: 0 0.3rem;\r\n  border-radius: 0.25rem;\r\n  background: #EDE3F7;\r\n  color: #7D48B0;\r\n  font-weight: 600;\r\n  font-size: 0.625rem;\r\n  line-height: 1.05rem;\r\n  letter-spacing: 0.0125rem;\r\n}\r\n\r\n.queue-item-date {\r\n  margin-top: 0.1rem;\r\n  font-size: 0.625rem;\r\n  color: #94A3B8;\r\n}\r\n\r\n/* ── Patient card ────────────────────────────────────────────────────────── */\r\n.patient-card {\r\n  padding: 0.625rem 0.75rem;\r\n  border-bottom: 0.0625rem solid #E2E8F1;\r\n}\r\n.patient-card-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.8125rem;\r\n  color: #0F172A;\r\n}\r\n.patient-card-icon {\r\n  font-size: 0.875rem;\r\n  color: #7D48B0;\r\n}\r\n.patient-card-meta {\r\n  margin-top: 0.2rem;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-size: 0.6875rem;\r\n  line-height: 1.3;\r\n  color: #45556C;\r\n}\r\n.patient-card-actions {\r\n  margin-top: 0.5rem;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.4rem;\r\n}\r\n.rail-action-btn {\r\n  height: 1.6rem;\r\n  padding: 0 0.6rem;\r\n  border-radius: 0.375rem;\r\n  border: 0.0625rem solid #7D48B0;\r\n  background: #fff;\r\n  color: #7D48B0;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n.rail-action-btn:hover {\r\n  background: #F5EBFF !important;\r\n  border-color: #7D48B0 !important;\r\n  color: #7D48B0 !important;\r\n}\r\n\r\n/* ── Editor section (max space) ──────────────────────────────────────────── */\r\n.editor-section {\r\n  flex: 1 1 auto;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.section-header {\r\n  flex: 0 0 auto;\r\n  height: 2.25rem;\r\n  padding: 0 1rem;\r\n  background: #7D48B0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.section-header-title {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  letter-spacing: 0.0025rem;\r\n  color: #fff;\r\n}\r\n\r\n.section-content {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n}\r\n\r\n.section-footer {\r\n  flex: 0 0 auto;\r\n  padding: 0.5rem 0.75rem;\r\n  background: #fff;\r\n  border-top: 0.0625rem solid #E2E8F1;\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.signed-off-banner {\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* ── Footer buttons ──────────────────────────────────────────────────────── */\r\n.footer-btn {\r\n  height: 1.75rem;\r\n  padding: 0.375rem 0.625rem;\r\n  border-radius: 0.5rem;\r\n  background-color: #fff;\r\n  border: 0.0625rem solid #D5DEE6;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.8125rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.0025rem;\r\n}\r\n\r\n.footer-btn-signoff {\r\n  height: 1.75rem;\r\n  padding: 0.375rem 0.625rem;\r\n  border-radius: 0.5rem;\r\n  background-color: #7D48B0;\r\n  border: 0.0625rem solid #7D48B0;\r\n  color: #fff;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.8125rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.0025rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n.footer-btn-signoff:hover {\r\n  background-color: #6A3D9A !important;\r\n  border-color: #6A3D9A !important;\r\n  color: #fff !important;\r\n}\r\n\r\n/* Red variant for \"Update Sign-off\" (editing an already signed-off report) */\r\n.footer-btn-signoff-update {\r\n  background-color: #D4380D !important;\r\n  border-color: #D4380D !important;\r\n}\r\n.footer-btn-signoff-update:hover {\r\n  background-color: #AD2102 !important;\r\n  border-color: #AD2102 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n/* Template panel buttons (rendered by TemplatePanel) */\r\n.use-template-btn {\r\n  height: 1.75rem;\r\n  padding: 0.375rem 0.625rem;\r\n  gap: 0.375rem;\r\n  border-radius: 0.5rem;\r\n  background: #fff;\r\n  border: 0.0625rem solid #7D48B0 !important;\r\n  box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;\r\n  display: flex;\r\n  align-items: center;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.8125rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.0025rem;\r\n  color: #7D48B0 !important;\r\n}\r\n.use-template-btn:hover {\r\n  background: #F5EBFF !important;\r\n  border-color: #7D48B0 !important;\r\n  color: #7D48B0 !important;\r\n}\r\n\r\n.voice-transcribe-btn {\r\n  height: 1.75rem;\r\n  padding: 0.375rem 0.625rem;\r\n  gap: 0.375rem;\r\n  border-radius: 0.5rem;\r\n  background: #fff !important;\r\n  border: 0.125rem solid transparent !important;\r\n  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #8149C4 0%, #25E228 100%) !important;\r\n  background-origin: border-box !important;\r\n  background-clip: padding-box, border-box !important;\r\n  box-shadow: 0.0625rem 0.0625rem 0.125rem 0rem #1832470A;\r\n  display: flex;\r\n  align-items: center;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.8125rem;\r\n  line-height: 1.25rem;\r\n  letter-spacing: 0.0025rem;\r\n  color: #7D48B0 !important;\r\n}\r\n.voice-transcribe-btn:hover {\r\n  background-image: linear-gradient(#F5EBFF, #F5EBFF), linear-gradient(90deg, #8149C4 0%, #25E228 100%) !important;\r\n  background-origin: border-box !important;\r\n  background-clip: padding-box, border-box !important;\r\n  color: #7D48B0 !important;\r\n}\r\n\r\n/* ── Collapsible panels (rail) ───────────────────────────────────────────── */\r\n.collapsible-section {\r\n  border-bottom: 0.0625rem solid #E2E8F1;\r\n  background: #fff;\r\n}\r\n.collapsible-header {\r\n  height: 2.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 0.75rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n.collapsible-header:hover {\r\n  background-color: #F8F9FA;\r\n}\r\n.collapsible-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n.collapsible-icon {\r\n  font-size: 0.875rem;\r\n  color: #45556C;\r\n}\r\n.collapsible-title {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 600;\r\n  font-size: 0.8125rem;\r\n  letter-spacing: 0.0025rem;\r\n  color: #0F172A;\r\n}\r\n.collapsible-arrow {\r\n  font-size: 0.6875rem;\r\n  color: #94A3B8;\r\n  transition: transform 0.2s;\r\n}\r\n.collapsible-content {\r\n  padding: 0.5rem 0.75rem;\r\n  background: #fff;\r\n}\r\n\r\n/* ── Report / prior list items ───────────────────────────────────────────── */\r\n.report-list-item {\r\n  padding: 0.4rem 0;\r\n  border-bottom: 0.0625rem solid #EEF2F6;\r\n  cursor: pointer;\r\n}\r\n.report-list-item:last-child {\r\n  border-bottom: none;\r\n}\r\n.report-list-item:hover {\r\n  background-color: #F8F9FA;\r\n}\r\n.report-item-line-1 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 400;\r\n  font-size: 0.75rem;\r\n  color: #0F172A;\r\n  margin-bottom: 0.15rem;\r\n}\r\n.report-item-line-2 {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-size: 0.6875rem;\r\n  color: #45556C;\r\n  margin-bottom: 0.2rem;\r\n}\r\n.report-item-line-3 {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.no-content-message {\r\n  text-align: center;\r\n  color: #94A3B8;\r\n  padding: 0.5rem 0;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n/* Documents / notes list */\r\n.report-notes-list {\r\n  padding: 0.4rem 0.5rem;\r\n  margin-bottom: 0.25rem;\r\n  background-color: #F5F5F5;\r\n  border-radius: 0.25rem;\r\n  font-size: 0.75rem;\r\n  cursor: pointer;\r\n  border: 0.0625rem solid #E8E8E8;\r\n  transition: all 0.2s;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.report-notes-list.selected {\r\n  color: #000 !important;\r\n  border: none;\r\n  background: #A27EC3 !important;\r\n}\r\n\r\n/* ── Advanced options ────────────────────────────────────────────────────── */\r\n.advanced-option-item {\r\n  margin-bottom: 0.625rem;\r\n}\r\n.advanced-option-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n.notify-physician-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  color: #7D48B0;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.8125rem;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  transition: all 0.2s;\r\n}\r\n.notify-physician-link:hover {\r\n  color: #6A3D9A;\r\n  text-decoration: underline;\r\n}\r\n.notify-bell-icon {\r\n  font-size: 0.875rem;\r\n  color: #7D48B0;\r\n}\r\n.advanced-option-checkbox {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-size: 0.8125rem;\r\n  color: #0F172A;\r\n}\r\n.advanced-option-radio-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n}\r\n.radio-label {\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-weight: 500;\r\n  font-size: 0.8125rem;\r\n  color: #0F172A;\r\n}\r\n.error-message {\r\n  color: #FF4D4F;\r\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\r\n  font-size: 0.75rem;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n/* ── External report header/footer (TinyMCE legacy support) ──────────────── */\r\n#external-report-header {\r\n  background: #fff;\r\n  padding: 0.5rem 1.25rem;\r\n  border-bottom: 0.0625rem solid #E8E8E8;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n#external-report-header strong {\r\n  font-weight: 700;\r\n}\r\n#external-report-footer {\r\n  background: #fff;\r\n  padding: 0.375rem 1.25rem;\r\n  border-top: 0.0625rem solid #E8E8E8;\r\n  font-size: 0.8125rem;\r\n  color: #333;\r\n  line-height: 1.4;\r\n  text-align: left;\r\n}\r\n\r\n/* ── TinyMCE toolbar tweaks ──────────────────────────────────────────────── */\r\n.tox-tinymce {\r\n  border-radius: 0 !important;\r\n  width: 100% !important;\r\n}\r\n.tox-tinymce .tox-edit-area {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.tox-tinymce .tox-edit-area__iframe {\r\n  max-width: 49.625rem;\r\n  width: 49.625rem;\r\n}\r\n.tox button[data-mce-name=\"fontsize\"],\r\n.tox .tox-tbtn[data-mce-name=\"fontsize\"] {\r\n  width: 70px !important;\r\n  max-width: 70px !important;\r\n  min-width: 70px !important;\r\n}\r\n.tox button[data-mce-name=\"fontfamily\"],\r\n.tox .tox-tbtn[data-mce-name=\"fontfamily\"] {\r\n  width: 85px !important;\r\n  max-width: 85px !important;\r\n  min-width: 85px !important;\r\n}\r\n.tox button[data-mce-name=\"styles\"],\r\n.tox .tox-tbtn[data-mce-name=\"styles\"] {\r\n  width: 100px !important;\r\n  max-width: 100px !important;\r\n  min-width: 100px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
